import Swal from "sweetalert2";
import "./CustomQuickActionRun.css";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { BASEURL } from "../../../../config";
import TextArea from "antd/es/input/TextArea";
import { Input, Form, Button, Drawer } from "antd";
import authAxios from "../../../../Config/AuthAxios";

const WriteOrPaste = ({
  isOpenWitreOrPasteDrawer,
  setIsOpenWitreOrPasteDrawer,
  setUploadComputerData,
}) => {
  const SideClose = "/assets/ModalClose.svg";

  const params = useParams();
  const [form] = Form.useForm();
  const [createDataLoader, setCreateDataLoader] = useState(false);

  const onClose = () => {
    setIsOpenWitreOrPasteDrawer(false);
    form.resetFields();
  };

  const handleCreateWriteOrPasteData = async (event) => {
    const token = localStorage.getItem("token");
    const payload = {
      file_name: event.title,
      text: event.description,
    };

    try {
      setCreateDataLoader(true);
      const res = await authAxios({
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
        url: BASEURL + `quick-action/${params?.id}/run/custom-qa-create-file`,
        data: payload,
      });

      if (res?.status === 200) {
        const uploadedFileData = res?.data;
        if (uploadedFileData) {
          setUploadComputerData((prevData) => [...prevData, uploadedFileData]);
        }
      }

      setIsOpenWitreOrPasteDrawer(false);
      form.resetFields();
      setCreateDataLoader(false);
    } catch (err) {
      const fileError = err?.response?.data?.data?.file[0];
      if (fileError !== undefined) {
        Swal.fire(fileError);
      } else {
        Swal.fire(err);
      }
      setCreateDataLoader(false);
    } finally {
      setCreateDataLoader(false);
    }
  };

  return (
    <>
      <Drawer
        title=""
        onClose={onClose}
        open={isOpenWitreOrPasteDrawer}
        width={"45%"}
      >
        {createDataLoader && (
          <div className="write-or-paste-loader-overlay">
            <div className="write-or-paste-loader"></div>
          </div>
        )}
        <img
          className="supporting-document-modal-sideClose"
          src={SideClose}
          alt=""
          onClick={onClose}
        />
        <h1>Write or Paste Text</h1>
        <Form
          form={form}
          name="owndata"
          initialValues={{ remember: true }}
          onFinish={handleCreateWriteOrPasteData}
          style={{
            margin: "auto",
            marginTop: "30px",
          }}
        >
          <label>Title</label>
          <Form.Item
            name="title"
            rules={[
              {
                required: true,
                message: "Please input Title",
              },
              {
                type: "text",
                message: "Please enter a Title",
              },
            ]}
          >
            <Input placeholder="Write Title" />
          </Form.Item>
          <label>Text</label>
          <Form.Item
            name="description"
            rules={[
              {
                required: true,
                message: "Please Description",
              },
              {
                type: "text",
                message: "Please enter a Description",
              },
            ]}
          >
            <TextArea placeholder="Write Something" rows={15} />
          </Form.Item>
          <Form.Item className="text-center">
            <Button
              style={{ marginTop: "20px", width: "unset" }}
              type="primary"
              htmlType="submit"
              block
              className="submit_login-btn"
            >
              Add Text
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default WriteOrPaste;
